import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";

// Css
import classes from "./ClusterStatus.module.css";

// Mui & Jds
import { BadgeV2, Button, Container, Icon, ProgressBar, Text } from "@jds/core";
import { Box, Stack } from "@mui/material";

// Local
import useApiHttp from "../../../hooks/use-http";
import { removeUnderscore, capitalizeWords } from "../../../util/helper";

const progressBarStyle = {
  '& .j-JDSProgressBar-container': {
    gap: '8px'
  }
}

const HeaderContent = (props) => {

}

const ClusterStatus = ({
  clusterStatusProp = {},
  setClusterStatusProp = () => { },
  closeModal = () => { },
  setRefetchAftClu = () => { },
  clusteringAttempt = 0,
}) => {
  const [clusterStatus, setClusterStatus] = useState(null);
  const { sendRequest: clusterStatusReq, isLoading: isclusterStatusLoading } =
    useApiHttp();
  const { id: eventId } = useParams();
  const clusterStatusAbort = useRef(null);

  let HeaderContent =

    <Stack gap={0.5}>
      <Text text={'Your photos are being prepared'} appearance="heading_xs" />
      <Text
        text={`Please wait while we process and group your faces`}
        appearance="body_s"
        color="primary-grey-80"
      />
    </Stack>

  if (clusterStatus?.stage === 'CROP_FACES' && clusterStatus?.status === 'COMPLETED' && !clusterStatus?.hasNewUploads) {
    // HeaderContent = <Text text="Your Photos are ready to be shared." appearance="heading_xs" />
    HeaderContent = <Stack gap={0.5}>
      <Text text={'Your Photos are ready to be shared'} appearance="heading_xs" />
      <Text
        text={`You can now review and share your processed photos`}
        appearance="body_s"
        color="primary-grey-80"
      />
    </Stack>
  } else if (clusterStatus?.status === 'FAILED') {
    HeaderContent = <Text text="Processing failed!" appearance="heading_xs" color="feedback-error-50" />
  }

  useEffect(() => {
    setClusterStatus(clusterStatusProp);
    const interval = setInterval(() => {
      const abortController = new AbortController();
      clusterStatusAbort.current = {
        id: `${Date.now()}-${Math.random()}`,
        controller: abortController,
      };
      clusterStatusReq(
        {
          url: `face/cluster/status/${eventId}`,
          method: "GET",
          base: "MEDIA",
          signal: abortController?.signal,
        },
        null,
        (data) => {
          setClusterStatus(data?.data);
          setClusterStatusProp(data?.data);
          if (
            data?.data?.status == "COMPLETED" ||
            clusteringAttempt !== data?.data?.clusteringAttempt
          ) {
            // closeModal();
            setRefetchAftClu(true);
          }
        },
        (err) => {
          setClusterStatus(null);
        }
      );
    }, 3000);
    return () => {
      clearInterval(interval);
      clusterStatusAbort?.current?.controller?.abort();
    };
  }, []);

  return (
    <>
      <div className={classes["cluster-alert-modal"]}>

        <Box position='absolute' sx={{ top: '42px', width: 'calc(100% - 112px)', backgroundColor: 'white', paddingBottom: '16px' }}>
          {HeaderContent}
          {/* <Stack gap={0.5}>
              <Text text={clusterStatus?.status === 'FAILED' ? 'Processing failed!' : 'Your Photo Is Being Prepared.'} appearance="heading_xs" color={clusterStatus?.status === 'FAILED' ? 'feedback-error-50' : ''} />
              {clusterStatus?.status !== 'FAILED' &&
                <Text
                  text={`Please wait while we process and group your faces.`}
                  appearance="body_s"
                  color="primary-grey-80"
                />}
            </Stack> */}
        </Box>

        {/* New UI */}
        {clusterStatus?.status === 'FAILED' ?
          <Stack mt={2} gap={2}>
            <Text text="We're experiencing technical issues while processing your photos. Please try again by clicking the button below." appearance="body-s" />
            {/* <Button iconLeft={'IcRefresh'} label="Retry processing" /> */}
          </Stack>
          :
          <Stack gap={3} mt={5}>
            <Stack direction="row" alignItems='center' gap={1}>
              <Icon ic={'IcCamera'} />
              <Text text="Total Faces Detected :" />
              <Text text={`${clusterStatus?.totalFaces}`} appearance="body-s-bold" />
            </Stack>
            <Box>
              <Stack direction="row" gap={1}>
                <Icon ic={'IcGroup'} />
                {/* <Text text="Grouping Similar Faces" /> */}
                <Box width={300} sx={progressBarStyle}>
                  <ProgressBar
                    label="Grouping Similar Faces"
                    value={clusterStatus?.clusterPercentage}
                    state={clusterStatus?.clusterPercentage === 100 ? 'success' : 'warning'}
                    valueLabel={
                      clusterStatus?.stage === "CLUSTERING" && (clusterStatus?.status === 'PENDING' || clusterStatus?.status === 'QUEUED') &&
                      <BadgeV2 label={`${clusterStatus?.status && capitalizeWords(clusterStatus?.status)}`} statusKind="icon-label" icon={clusterStatus?.status === 'PENDING' ? 'IcTime' : clusterStatus?.status === 'QUEUED' ? 'IcRefund' : ''} color={clusterStatus?.status === 'QUEUED' ? 'neutral' : ''} />
                    }
                  />
                </Box>
              </Stack>
              <Stack direction="row" ml={4} mt={2} gap={1}>
                <BadgeV2 label={`Pending : ${clusterStatus?.nonProcessedFaces}`} informationKind="label" status="warning" appearance="subtle" size="xtra-large" />
                <BadgeV2 label={`Completed : ${clusterStatus?.processedFaces}`} informationKind="label" color="positive" appearance="subtle" size="xtra-large" />
              </Stack>
            </Box>
            <Stack gap={1}>
              <Stack direction="row" alignItems='center' gap={1}>
                <Icon ic={'IcSmileySatisfied'} />
                <Stack direction="row" alignItems="center" gap={0.5}>
                  <Text text="Profile Pictures Processed" />
                  <Text text="(Host Profile Included)" appearance="body-xs" color="primary-grey-80" />
                </Stack>
              </Stack>
              <Stack direction="row" ml={4} gap={1} flexWrap={'wrap'}>
                <BadgeV2 label={`Pending : ${clusterStatus?.nonClusteredProfiles}`} informationKind="label" status="warning" appearance="subtle" size="xtra-large" />
                <BadgeV2 label={`Completed : ${clusterStatus?.clusteredProfiles}`} informationKind="label" color="positive" appearance="subtle" size="xtra-large" />
                <BadgeV2 label={`Rejected : ${clusterStatus?.rejectedProfiles}`} informationKind="label" color="negative" appearance="subtle" size="xtra-large" />
              </Stack>
            </Stack>
            <Stack direction="row" alignItems='center' gap={1}>
              <Icon ic={'IcProfile'} />
              <Text text="Total Unique Faces :" />
              <Text text={`${clusterStatus?.totalUniqueFaces}`} appearance="body-s-bold" />
            </Stack>
            <Box>
              <Stack direction="row" gap={1}>
                <Icon ic={'IcCropOriginal'} />
                {/* <Text text="Cropping Unique Faces" /> */}
                <Box width={300} sx={progressBarStyle}>
                  <ProgressBar
                    label="Face Thumbnail Generated"
                    value={clusterStatus?.cropPercentage}
                    state={clusterStatus?.cropPercentage === 100 ? 'success' : 'warning'}
                    valueLabel={
                      clusterStatus?.stage === "CROP_FACES" && (clusterStatus?.status === 'PENDING' || clusterStatus?.status === 'QUEUED') &&
                      <BadgeV2 label={`${clusterStatus?.status && capitalizeWords(clusterStatus?.status)}`} statusKind="icon-label" icon={clusterStatus?.status === 'PENDING' ? 'IcTime' : clusterStatus?.status === 'QUEUED' ? 'IcRefund' : ''} color={clusterStatus?.status === 'QUEUED' ? 'neutral' : ''} />
                    }
                  />
                </Box>
              </Stack>
              <Stack direction="row" ml={4} mt={1} gap={1}>
                <BadgeV2 label={`Pending : ${clusterStatus?.pendingUniqueFaces}`} informationKind="label" status="warning" appearance="subtle" size="xtra-large" />
                <BadgeV2 label={`Completed : ${clusterStatus?.completedUniqueFaces}`} informationKind="label" color="positive" appearance="subtle" size="xtra-large" />
              </Stack>
            </Box>
            <Stack direction="row" alignItems='center' gap={1}>
              <Icon ic={'IcTime'} />
              <Text text="Photos in Queue  : " />
              <Text text={clusterStatus?.hasNewUploads ? 'Yes' : 'No'} appearance="body-s-bold" />
            </Stack>
          </Stack>
        }
      </div>
    </>
  );
};

export default ClusterStatus;
